import React from 'react'
import { DATA } from '../data/products/ev-giyim-urunler-data'
import Urunler from '../pages/Urunler'
const EvGiyimUrunlerContainer = () => {
  return (
    <Urunler DATA={DATA}/>
  )
}

export default EvGiyimUrunlerContainer